<wf-dialog-content>
  <wf-loader [loading]="loading"></wf-loader>

  @if (!submitted) {
    <app-file-control
      [extensions]="['xlsx', 'xls']"
      (fileChange)="onFileSelect($event)"
    ></app-file-control>
  }
  @if (submitted && response && response.importedItemsCount) {
    <div>
      <p>
        <b>{{ 'Import_Success' | translate }}</b>
      </p>
      <p>
        <b>{{ 'Import_Success_File' | translate }}:</b> {{ response.fileName }}
      </p>
      <p>
        <b>{{ 'Import_Success_Number' | translate }}:</b>
        {{ response.importedItemsCount }}
      </p>
    </div>
  }
  @if (submitted && errorMessages?.length) {
    <div>
      <p>
        <b>{{ 'Import_Error' | translate }}</b>
      </p>
      @for (errorMessage of errorMessages; track $index) {
        <p>
          {{ errorMessage }}
        </p>
      }
    </div>
  }

  @if (templateUrl) {
    <div class="example-template">
      <a role="button" (click)="downloadExampleTemplate()">
        {{ 'DownloadExampleTemplate' | translate }}
      </a>
    </div>
  }
  @if (hasInfoBlock()) {
    <wf-alert-message
      [title]="'DOCUMENTS.GRID.IMPORT_BUTTON.Title' | translate"
      [text]="'DOCUMENTS.GRID.IMPORT_BUTTON.Text' | translate"
    >
    </wf-alert-message>
  }
</wf-dialog-content>
<wf-dialog-actions>
  @if (submitted) {
    <button wui-stroked-button (click)="dialogRef.close()">
      {{ 'Close' | translate }}
    </button>
  } @else {
    <button
      wui-flat-button
      color="primary"
      [disabled]="!file"
      (click)="onSubmit()"
    >
      {{ 'Import' | translate }}
    </button>
  }
</wf-dialog-actions>
